module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/wedding-og-image-a0cb62c77d0dc4d8e9facbac404141f6.png";